const convertLanguage = (selectedLang) => {
  const languages = {
    en_AU: 'en',
    en_US: 'en',
    en_CA: 'en',
    es_US: 'es',
    en_BR: 'en',
    en_NZ: 'en',
    hd_IN: 'hi',
    kr_KR: 'ko',
    pt_PT: 'pt',
    PN_PN: 'pu',
    FL_FL: 'fl',
    ar_SA: 'ar',
    so_SO: 'so',
    ur_UR: 'ur',
    ht_HT: 'ht',
    vi_VI: 'vi',
    it_IT: 'it',
    gr_GR: 'gr',
    fr_CA: 'fr',
    RU_RU: 'ru',
    KH_KH: 'kh',
    fa_IR: 'fa',
    sp_CH: 'zh_Hans',
    tr_CH: 'zh_Hant',
  };

  return languages[selectedLang];
};

export default convertLanguage;
